<template>



  <div         style=" border:solid #E3E4E8 1px;padding:5px;border-radius:3px">

  <div   style="min-width:250px"  >
  <div    style="margin-top: 0px;">

  <div  style="font-size:1.2em " >

  <div  v-ripple v-if="contentMenegment.items.selector.active === true" @click='selectAll()' class=" meneg_item"><span   v-if=" foundData.selector === false ">   Выбрать все </span> <span v-else > Отменить </span> </div>
  <div   v-ripple  v-if="contentMenegment.items.copy.active === true" @click='copy()' class="meneg_item">Запомнить {{this.foundData.selectedIds.length}}</div>
  <div   v-ripple  v-if="this.$store.state.memory[contentMenegment.contentInfo.type]" @click='unCopy()' class="meneg_item">Забыть {{this.$store.state.memory[contentMenegment.contentInfo.type]}}</div>

<div v-if="contentMenegment.items.toDone">
  <div   v-ripple   v-if="contentMenegment.items.toDone.active === true" @click='toDone()' class="meneg_item" > В обработанные {{this.foundData.selectedIds.length}}  </div>
</div>
<div v-if="contentMenegment.items.toUnDone">
  <div   v-ripple   v-if="contentMenegment.items.toUnDone.active === true" @click='toUnDone()' class="meneg_item" > Во входящий трафик {{this.foundData.selectedIds.length}}  </div>
</div>
<div v-if="contentMenegment.items.toTail">
  <div   v-ripple   v-if="contentMenegment.items.toTail.active === true" @click='toTail()' class="meneg_item" > В очередь {{this.foundData.selectedIds.length}}  </div>
</div>
<div v-if="contentMenegment.items.toMinus_traff">
  <div   v-ripple   v-if="contentMenegment.items.toMinus_traff.active === true" @click='toMinus_traff()' class="meneg_item" > В исключения {{this.foundData.selectedIds.length}}  </div>
</div>
<div v-if="contentMenegment.items.toBots">
  <div   v-ripple   v-if="contentMenegment.items.toBots.active === true" @click='toBots()' class="meneg_item" > В бот фильтр {{this.foundData.selectedIds.length}}  </div>
</div>
  <div   v-ripple   v-if="contentMenegment.items.export.active === true" @click='toExports()' class="meneg_item" > Экспортировать {{this.foundData.selectedIds.length}}  </div>
  <div v-ripple v-if="contentMenegment.items.update.active === true" class="meneg_item" > Обновить </div>
  <div v-ripple v-if="contentMenegment.items.delete.active === true" class="meneg_item" > Удалить </div>
  <div  v-ripple  v-if="contentMenegment.items.autoExport.active === true" @click='autoExports()' class="meneg_item" ><span v-if="!this.contentMenegment.autoExport.isActive"> АвтоЭкспорт</span>  <span v-if="this.contentMenegment.autoExport.isActive"> Отменить АвтоЭкспорт</span></div>
  <div  v-ripple  v-if="contentMenegment.items.autoExport.active === true" @click='txtsL()' class="meneg_item" ><span v-if="!this.contentMenegment.txtAutoExport.isActive"> TXT экспорт</span>  <span v-if="this.contentMenegment.txtAutoExport.isActive"> Отменить txt экспорт</span></div>

  <div v-if="contentMenegment.contentInfo.type  === 'pages' || contentMenegment.contentInfo.type  === 'groups' "  @click='exel()' v-ripple   class="meneg_item" > Создать excel </div>
  <div v-if="contentMenegment.contentInfo.type  === 'pages' || contentMenegment.contentInfo.type  === 'groups' || contentMenegment.contentInfo.type  === 'posts'"  @click='txts()' v-ripple   class="meneg_item" > Создать txt </div>


  </div>

  </div>
  </div>



  <v-dialog v-model="toExport.dialog" scrollable max-width="300px">
      <v-card>
        <v-card-title> <v-icon medium left style="marginRight:5px"  >mdi-export</v-icon> <span style="color:#757575;font-size:1.2em">  Экспорт  в задания</span>
        <v-spacer></v-spacer>
        <v-icon>mdi-close</v-icon>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text fluid   style="height: 300px;">

          <div  v-if="toExport.loading && toExport.tasksList.length<1" class="text-xs-center">
<v-progress-circular

  :size="70"
  :width="7"
  color="#4A76A8"
  indeterminate
></v-progress-circular>
          </div>

          <div v-for=" item  in this.toExport.tasksList" >
          <v-checkbox color="#4A76A8" v-model="tasks.selected"  v-bind ='[{label:item.name},{value:item.task_id}]'     ></v-checkbox>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A76A8" flat small   @click.native="toExport.dialog = false">Закрыть</v-btn>
          <v-btn v-if='tasks.selected.length>0' :loading="toExport.adding"  :disabled="toExport.adding" color="#4A76A8" small class="white--text"  @click="exportResources()">Выбрать</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>



  <v-dialog v-model="toExport.dialogAuto" scrollable max-width="650px">
      <v-card>
        <v-card-title> <v-icon color="#C46B19" medium left style="marginRight:10px"  >mdi-export</v-icon> <span style="color:#4A76A8;font-size:1.2em; font-weight:bold">  АвтоЭкспорт ресурсов в задания </span>
        <v-spacer></v-spacer>
        <v-icon @click="toExport.dialogAuto = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text fluid   >

<v-checkbox v-model="contentMenegment.autoExport.saveSourceInfo" label="Экспортировать данные об источниках ресурсов ? ">

</v-checkbox>

<v-divider style="color:#4A76A8"> </v-divider>


          <div  v-if="toExport.loading && toExport.tasksList.length<1" class="text-xs-center">
<v-progress-circular

  :size="70"
  :width="7"
  color="#4A76A8"
  indeterminate
></v-progress-circular>
          </div>
<p style="color:#757575;font-size:1.3em">
Выберите одно или несколько заданий
</p>

          <div v-for=" item  in this.toExport.tasksList" >
          <v-checkbox color="#4A76A8" v-model="contentMenegment.autoExport.tasksList"  v-bind ='[{label:item.name},{value:item.task_id}]'     >

      <div slot="label">


              <v-flex v-if="JSON.parse(item.status).status == 'stop'">
          <div>  <span style="font-size:1.1em; font-weight:bold; color:#4A76A8"> {{item.name   }}  </span> </div>
          <div>  <span style="color:#757575"> Не запущено</span> </div>
             </v-flex>

              <v-flex v-else-if="JSON.parse(item.status).status == 'error'">
          <div>  <span style="font-size:1.1em;  font-weight:bold; color:#4A76A8"> {{item.name   }}  </span> </div>
          <div>  <span style="color:red"> Остановлено с ошибкой </span> </div>
             </v-flex>

              <v-flex v-else>
          <div>  <span style="font-size:1.1em; font-weight:bold; color:#4A76A8"> {{item.name   }}  </span> </div>
          <div>  <span style="color:green"> Активно работает </span> </div>
             </v-flex>


      </div>

          </v-checkbox>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A76A8" flat small   @click.native="toExport.dialogAuto = false">Закрыть</v-btn>
          <v-btn v-if='contentMenegment.autoExport.tasksList.length>0' :loading="toExport.adding"  :disabled="toExport.adding" color="#4A76A8" small class="white--text"  @click="activateAutoExport()">Выбрать</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>



  <v-snackbar
    v-model="sb.snackbar"
    :color="sb.color"
    center top
    :absolute = "contentMenegment.snackbarAbsoute"
    :timeout="2000"

  >
    {{ sb.text  }}
    <v-btn
      dark
      flat
      @click="sb.snackbar = false"
    >
      ОК
    </v-btn>
  </v-snackbar>






  <v-dialog v-model="excel.modal" scrollable  width="750px" >





      <v-card>
        <v-snackbar
          v-model="excel.sb.snackbar"
          :color="excel.sb.color"
          center top
           absolute

          :timeout="2000"

        >
          {{ excel.sb.text  }}
          <v-btn
            dark
            flat
            @click="excel.sb.snackbar = false"
          >
            ОК
          </v-btn>
        </v-snackbar>
        <v-card-title> <v-icon medium left style="marginRight:5px"  >mdi-file-excel</v-icon><span style="color:#757575;font-size:1.2em"> Создать excel файл  </span></v-card-title>
        <v-divider></v-divider>
        <v-card-text fluid   style="height: 750px;">


         <v-text-field clearable v-model="excel.excelTitle" color="#4A76A8" label="Название таблицы"> </v-text-field>

          <span style="color:#757575">Выберите необходимые поля</span>


          <div v-if="contentMenegment.contentInfo.type=='pages'" v-for=" item  in excel.itemsPages" >
          <v-checkbox color="#4A76A8" v-model="excel.selected"  v-bind ='[{label:item.title},{value:item.value}]'     ></v-checkbox>
          </div>

          <div v-if="contentMenegment.contentInfo.type=='groups'" v-for=" item  in excel.itemsGroups" >
          <v-checkbox color="#4A76A8" v-model="excel.selected"  v-bind ='[{label:item.title},{value:item.value}]'     ></v-checkbox>
          </div>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="excel.modal = false"    color="#4A76A8" flat small   >Закрыть</v-btn>
          <v-btn @click.native="excelCreate()"  :loading="excel.loading"  :disabled="excel.loading"  color="#4A76A8" small class="white--text">Создать</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>



<v-dialog v-model="txt.modal" width="750" scrollable persistent>

  <v-card >
    <v-card-title> <v-icon medium left style="marginRight:5px"  >mdi-comment-text</v-icon><span style="color:#757575;font-size:1.2em"> Создать txt файл  </span>  <v-spacer></v-spacer>  <v-icon  @click.native="txt.modal = false">mdi-close</v-icon></v-card-title>
    <v-divider></v-divider>
<v-card-text>
<v-text-field clearable v-model="txt.txtTitle" color="#4A76A8" label="Название текстового документа"> </v-text-field>
<v-switch  v-model="txt.newLines"  label="Использовать перенос строк ?"></v-switch>


<v-textarea
clearable
v-model="txt.pattern"
label="Введите паттерн строки"
>

</v-textarea>


<div >
  <p style="color:#757575;font-size:1.2em"> Теги вставки </p>

    <li v-for="item in txtTegs ">  <strong style="cursor:pointer" @click="addTag(item.value)">  {{item.value}} </strong> {{item.desc}} </li>


</div>



</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click.native="txt.modal = false"    color="primary" flat small   >Закрыть</v-btn>
  <v-btn @click.native="txtCreate()"  :loading="txt.loading"  :disabled="txt.loading"  color="primary" small class="white--text">Создать</v-btn>
</v-card-actions>
  </v-card>

</v-dialog>









<v-dialog v-model="txt.modalL" width="750" scrollable persistent>

  <v-card >
    <v-card-title> <v-icon medium left style="marginRight:5px"  >mdi-comment-text</v-icon><span style="color:#757575;font-size:1.2em"> АвтоЭкспорт в TXT  </span>  <v-spacer></v-spacer>  <v-icon  @click.native="txt.modalL = false">mdi-close</v-icon></v-card-title>
    <v-divider></v-divider>
<v-card-text>
<v-text-field clearable v-model="txt.txtTitle" color="#4A76A8" label="Название текстового документа"> </v-text-field>
<v-switch  v-model="txt.newLines"  label="Использовать перенос строк ?"></v-switch>


<v-textarea
clearable
v-model="txt.pattern"
label="Введите паттерн строки"
>

</v-textarea>


<div >
  <p style="color:#757575;font-size:1.2em"> Теги вставки </p>

    <li v-for="item in txtTegs ">  <strong style="cursor:pointer" @click="addTag(item.value)">  {{item.value}} </strong> {{item.desc}} </li>


</div>



</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click.native="txt.modalL = false"    color="primary" flat small   >Закрыть</v-btn>
  <v-btn @click.native="txtAutoStart()"  :loading="txt.loading"  :disabled="txt.loading"  color="primary" small class="white--text">Активировать</v-btn>
</v-card-actions>
  </v-card>

</v-dialog>



















  </div>
</template>




<script>
import axios from 'axios'
 export default {
 props : [ 'foundData','contentMenegment' ],
 data(){
   return {

     txt:{
       modalL: false,
       sb:{
       snackbar: false,
       color: 'success',
       text: ''
          },
       loading: false,
       txtTitle:"vkplus_txt",
       newLines: true,
       pattern: "",

       tagsPosts:[
                  {
                   value: "[text]",
                   desc: " - Текст",
                  },
                  {
                   value: "[id]",
                   desc: " - Цифровое id поста ",
                  },
                  {
                   value: "[owner]",
                   desc: " - Цифровое id владельца поста",
                  },
                  {
                   value: "[likes]",
                   desc: " - Колличество лайков ",
                  },
                  {
                   value: "[reposts]",
                   desc: " - Колличество репостов",
                  },
                  {
                   value: "[comments]",
                   desc: " - Колличество комментариев",
                  },
                  {
                   value: "[views]",
                   desc: " - Колличество просмотров ",
                  },
                  {
                  value: "[time]",
                  desc: " - Время публикации",
                  },
                  {
                  value: "[new_line]",
                  desc: " - Перенос строки ",
                  },
                  {
                  value: "[n]",
                  desc: " - Порядковый номер пользователя ",
                  },

       ],
       tagsGroups:[
                  {
                   value: "[id]",
                   desc: " - Цифровое id  ",
                  },
                  {
                   value: "[name]",
                   desc: " - Название ",
                  },
                  {
                   value: "[screen_name]",
                   desc: " - Короткий адресс",
                  },
                  {
                   value: "[city]",
                   desc: " - Город",
                  },
                  {
                   value: "[country]",
                   desc: " - Страна ",
                  },
                  {
                   value: "[description]",
                   desc: " - Описание ",
                  },
                  {
                   value: "[members_count]",
                   desc: " - Колличество подписчиков ",
                  },
                  {
                   value: "[can_post]",
                   desc: " - Есть ли возможность оставить пост? ",
                  },
                  {
                   value: "[status]",
                   desc: " - Статус ",
                  },
                  {
                   value: "[wiki_page]",
                   desc: " - Название вики страницы ",
                  },
                  {
                   value: "[activity]",
                   desc: " - Открытость сообщества или дата начала события",
                  },
                  {
                   value: "[new_line]",
                   desc: " - Перенос строки ",
                 },
                 {
                   value: "[n]",
                   desc: " - Порядковый номер сообщества",
                  },
       ],
       tags: [
         {
          value: "[id]",
          desc: " - Цифровое id ",
         },
         {
          value: "[first_name]",
          desc: " - Имя пользователя ",
         },
         {
          value: "[last_name]",
          desc: " - Фамилия пользователя ",
         },
         {
          value: "[status]",
          desc: " - Статус пользователя ",
         },
         {
          value: "[last_seen]",
          desc: " - Последний вход пользователя в сеть ",
         },
         {
          value: "[followers_count]",
          desc: " - Колличество подписчиков пользователя ",
         },
         {
          value: "[new_line]",
          desc: " - Перенос строки ",
         },
         {
          value: "[n]",
          desc: " - Порядковый номер пользователя ",
         },
       ],


       modal:false,

     },



    excel:{
      sb:{
      snackbar: false,
      color: 'success',
      text: ''
         },
      loading: false,
      excelTitle:"tester",
      modal:false,
      selected:[],
      itemsPages:[
        {title:"Имя",value:"first_name"},
        {title:"Фамилия",value:"last_name"},
        {title:"Город",value:"city"},
        {title:"Мобильный телефон",value:"mobile_phone"},
        {title:"Сайт",value:"site"},
        {title:"Возраст",value:"bdate"},
        {title:"Cтатус",value:"status"},
        {title:"ID пользователя",value:"id"},

      ],
      itemsGroups:[
        {title:"Название сообщества",value:"name"},
        {title:"Тип сообщества",value:"type"},
        {title:"Колличество участников",value:"members_count"},
        {title:"Сайт",value:"site"},
        {title:"Cтатус сообщества",value:"status"},
        {title:"ID сообщества",value:"id"},

      ],
    },



     tasks:{
       selected:[]
     },
     sb:{
     snackbar: false,
     color: 'success',
     text: ''
   },
    toExport: {
      tasksList:[],
      dialogAuto: false,
      dialog : false,
      loading: true,
      adding: false,

    },


   }
 },
mounted(){
  //console.log(this.contentMenegment)
            if(this.contentMenegment.contentInfo.type  === 'pages'){
              this.txt.pattern = "https://vk.com/id[id]"
            } else if (this.contentMenegment.contentInfo.type  === 'groups') {
              this.txt.pattern = "https://vk.com/club[id]"
            }else if (this.contentMenegment.contentInfo.type  === 'posts') {
              this.txt.pattern =  "https://vk.com/wall[owner]_[id]"
            }
},
  computed : {

    txtTegs(){
            if(this.contentMenegment.contentInfo.type  === 'pages'){
              return this.txt.tags
            } else if (this.contentMenegment.contentInfo.type  === 'groups') {
              return this.txt.tagsGroups
            }else if (this.contentMenegment.contentInfo.type  === 'posts') {
              return this.txt.tagsPosts
            }
    },
  },



 methods : {

toDone(){
  if(this.foundData.selectedIds.length>0){
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/change_res_status.php', {
        method: 'POST',
        data: {
          contentType: this.contentMenegment.contentInfo.type,
          ids: this.foundData.selectedIds,
          act: "toDone",
          taskIds: this.contentMenegment.init.info.task_id
        }
      })
      .then( response => {
        // Заставляем обновить ресурсы
        this.contentMenegment.init.startUpdateRes = new Date()
      })

   this.sb.color = 'success'
   this.sb.text = 'Успешно переместили : '+this.foundData.selectedIds.length
   this.sb.snackbar = true
} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотябы один элемент'
this.sb.snackbar = true
}
},

toUnDone(){
if(this.foundData.selectedIds.length>0){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/change_res_status.php', {
method: 'POST',
data: {
contentType: this.contentMenegment.contentInfo.type,
ids: this.foundData.selectedIds,
act: "toUnDone",
taskIds: this.contentMenegment.init.info.task_id
}
})
.then( response => {
// Заставляем обновить ресурсы
this.contentMenegment.init.startUpdateRes = new Date()
})
this.sb.color = 'success'
this.sb.text = 'Успешно переместили : '+this.foundData.selectedIds.length
this.sb.snackbar = true

} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотябы один элемент'
this.sb.snackbar = true
}
},

toTail(){
if(this.foundData.selectedIds.length>0){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/change_res_status.php', {
method: 'POST',
data: {
contentType: this.contentMenegment.contentInfo.type,
ids: this.foundData.selectedIds,
act: "toTail",
taskIds: this.contentMenegment.init.info.task_id
}
})
.then( response => {
// Заставляем обновить ресурсы
this.contentMenegment.init.startUpdateRes = new Date()
})
this.sb.color = 'success'
this.sb.text = 'Успешно переместили : '+this.foundData.selectedIds.length
this.sb.snackbar = true

} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотябы один элемент'
this.sb.snackbar = true
}
},


toMinus_traff(){
if(this.foundData.selectedIds.length>0){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/change_res_status.php', {
method: 'POST',
data: {
contentType: this.contentMenegment.contentInfo.type,
ids: this.foundData.selectedIds,
act: "toMinus_traff",
taskIds: this.contentMenegment.init.info.task_id
}
})
.then( response => {
// Заставляем обновить ресурсы
this.contentMenegment.init.startUpdateRes = new Date()
})
this.sb.color = 'success'
this.sb.text = 'Успешно переместили : '+this.foundData.selectedIds.length
this.sb.snackbar = true

} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотябы один элемент'
this.sb.snackbar = true
}
},

toBots(){
if(this.foundData.selectedIds.length>0){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/change_res_status.php', {
method: 'POST',
data: {
contentType: this.contentMenegment.contentInfo.type,
ids: this.foundData.selectedIds,
act: "toBots",
taskIds: this.contentMenegment.init.info.task_id
}
})
.then( response => {
// Заставляем обновить ресурсы
this.contentMenegment.init.startUpdateRes = new Date()
})
this.sb.color = 'success'
this.sb.text = 'Успешно переместили : '+this.foundData.selectedIds.length
this.sb.snackbar = true

} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотябы один элемент'
this.sb.snackbar = true
}
},





   selectAll: function(){

     if(this.foundData.selector ===  true){

       this.foundData.selectedIds = []
       this.foundData.selector = false
       this.foundData.displayIds.forEach(function(item, i, arr){
       item.add_info.selected = false
       })



     }
     else {
       this.foundData.displayIds.forEach(function(item, i, arr){
         item.add_info.selected = true
       })
       this.foundData.selectedIds = []
       this.foundData.selectedIds =  this.foundData.selectedIds.concat(this.foundData.foundIds)
       this.foundData.selector = true

     }

   },
addTag(value){
                if(this.txt.pattern == null){this.txt.pattern = "" }
                this.txt.pattern += value

},

   txtsL (){
     if(this.contentMenegment.txtAutoExport.isActive){
       this.contentMenegment.txtAutoExport.isActive = false
     } else {
       this.txt.modalL = true
     }


   },

txtAutoStart: function(){
 this.txt.modalL = false
 this.contentMenegment.txtAutoExport.isActive = true
 this.contentMenegment.txtAutoExport.pattern = this.txt

},








   txts (){

     console.log(this.contentMenegment)
     console.log(this.foundData)
     if(this.foundData.selectedIds.length>0){
    this.txt.modal = true
} else {

 this.sb.color = 'error'
 this.sb.text = 'Выберите хотябы один элемент'
 this.sb.snackbar = true
}
   },
   txtCreate(){

if(true){

  this.txt.loading = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/txt/create_txt.php', {
       method: 'POST',
       responseType: 'file',
       data: {
         type : this.contentMenegment.contentInfo.type,
         pattern: this.txt.pattern,
         newLines: this.txt.newLines,
         ids: this.foundData.selectedIds,

       }
     })
     .then( response => {
       console.log(response.data)
       const url = window.URL.createObjectURL(new Blob([response.data]));
       const link = document.createElement('a');
       link.href = url;
       link.setAttribute('download', this.txt.txtTitle+'.txt');
       document.body.appendChild(link);
       link.click();
    this.txt.loading = false
     })
 } else {
   this.excel.sb.color = 'error'
   this.excel.sb.text = 'Выберите хотя бы одно поле'
   this.excel.sb.snackbar = true
 }

},













   exel: function(){

     console.log(this.contentMenegment)
     console.log(this.foundData)
     if(this.foundData.selectedIds.length>0){
    this.excel.modal = true
} else {

 this.sb.color = 'error'
 this.sb.text = 'Выберите хотябы один элемент'
 this.sb.snackbar = true
}
   },
   excelCreate(){

if(this.excel.selected.length > 0){

  this.excel.loading = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/excel/create_pages_list.php', {
       method: 'POST',
       //responseType: 'blob',
       data: {
         type : this.contentMenegment.contentInfo.type,
         title: this.excel.excelTitle,
         selectedFields: this.excel.selected,
         ids: this.foundData.selectedIds
       }
     })
     .then( response => {



        const link = document.createElement('a')
    link.href = 'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/excel/excel_pages/'+response.data.fileName
      link.setAttribute('download', response.data.fileName )
     document.body.appendChild(link)
       link.click()
       this.excel.loading = false
     })
 } else {
   this.excel.sb.color = 'error'
   this.excel.sb.text = 'Выберите хотя бы одно поле'
   this.excel.sb.snackbar = true
 }

},
   copy: function(){
      if(this.foundData.selectedIds.length>0){
       axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/memory/insert.php', {
            method: 'POST',
            data: {
              contentType: this.contentMenegment.contentInfo.type,
              ids: this.foundData.selectedIds,
            }
          })
          .then( response => {
        this.$store.state.memory[response.data.contentType] = response.data.count
              navigator.clipboard.writeText(this.foundData.selectedIds.join(','))
          })

       this.sb.color = 'success'
       this.sb.text = 'Запомненно еще : '+this.foundData.selectedIds.length
       this.sb.snackbar = true



} else {
  this.sb.color = 'error'
  this.sb.text = 'Выберите хотябы один элемент'
  this.sb.snackbar = true
}


   },

unCopy(){

   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/memory/clear_list.php', {
        method: 'POST',
        data: {
          contentType: this.contentMenegment.contentInfo.type,
        }
      })
      .then( response => {
    this.$store.state.memory[response.data.contentType] = response.data.count

      })
   this.sb.color = 'success'
   this.sb.text = 'Список запомненных успешно очищен'
   this.sb.snackbar = true


},





toExports: function(){

  if(this.foundData.selectedIds.length>0){
   this.toExport.dialog = true
   this.toExport.loading = true
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
        method: 'POST',
        data: {
          contentType: this.contentMenegment.contentInfo.type
        }
      })
      .then( response => {
        this.toExport.loading = false
        console.log(response.data)
        this.toExport.tasksList = response.data

      })
} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотябы один элемент'
this.sb.snackbar = true
}
},
exportResources: function(){

     this.toExport.adding = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/add_resourcess.php', {
       method: 'POST',
       data: {
       taskIds: this.tasks.selected,
       data: this.foundData.selectedIds
       }
     })
     .then( response => {
       console.log(response.data)
       this.toExport.adding = false
       this.toExport.dialog = false
       this.tasks.selected = []
       this.sb.color = 'success'
       this.sb.text = 'Успешный экспорт '+this.foundData.selectedIds.length
       this.sb.snackbar = true

     })
},

autoExports: function(){

  if(!this.contentMenegment.autoExport.isActive){
  this.toExport.dialogAuto = true
  this.toExport.loading = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
       method: 'POST',
       data: {
         contentType: this.contentMenegment.contentInfo.type
       }
     })
     .then( response => {
       this.toExport.loading = false
       console.log(response.data)
       this.toExport.tasksList = response.data

     })
   } else {
     this.contentMenegment.autoExport.isActive = false
   }
},
activateAutoExport: function(){
  this.contentMenegment.autoExport.isActive = true
  this.toExport.dialogAuto = false
}


}
 }
</script>



<style>

</style>
